<template>
  <div>
    <v-autocomplete
      class="app-custom-input"
      v-model="valueInput"
      :items="itemList"
      :loading="loading"
      :label="label"
      :placeholder="placeholder"
      hide-no-data
      :hide-details="hideNoDetail"
      return-object
      filled
      outlined
      :dense="isSmall"
      item-value="_id"
      item-text="value"
      :disabled="disabled"
      :rules="required ? validateRules : []"
      :clearable="clearable"
    >
    </v-autocomplete>
  </div>
</template>

<script>
import { getContractBySeachingService } from "@/services/api/contract";
import _ from "lodash";
export default {
  name: "JobContractSelectorInput",
  props: {
    value: {},
    label: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    hideNoDetail: {
      type: Boolean,
      default: true,
    },
    isSmall: {
      type: Boolean,
      default: true,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: true,
    },
    appendAllItems: {
      type: Boolean,
      default: false,
    },
    valueAllItem: {
      type: Object,
      default: () => {},
    },
  },

  data: () => ({
    itemList: [],
    loading: false,
    validateRules: [(v) => !!v || "จำเป็นต้องระบุสัญญา"],
  }),

  computed: {
    valueInput: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("searchItemChange", val);
      },
    },
  },

  methods: {
    async callApi() {
      this.loading = true;
      let rspData = await getContractBySeachingService(
        this.$store,
        null,
        "list"
      );

      if (rspData["code"] === 200) {
        this.itemList = _.reverse(rspData["data"]);
      } else {
        this.itemList = [];
      }

      if (this.appendAllItems) {
        this.itemList.push(this.valueAllItem);
      }

      this.$emit("update-items", this.itemList);
      this.loading = false;
    },
  },

  mounted() {
    this.callApi();
  },
};
</script>

<style></style>
